import { InjectionToken } from '@angular/core';

export type AccountDisplayTypes = 'main-menu' | 'side-menu';

export interface AccountModuleDisplayConfig {
    displayAreaConfig: AccountDisplayTypes;
}

export const ACCOUNT_DISPLAY_CONFIG = new InjectionToken(
  'ACCOUNT_DISPLAY_CONFIG'
);  